// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getComponentCodes} from '../../../shared/repositories';

export const readComponentCodes = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const componentCodes = await getComponentCodes();

            dispatch({
                componentCodes,
                type: actions.UPDATE_PRODUCT_DETAILS_COMPONENT_CODES
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/component-codes.js